import { VendorGetServerSideProps } from 'vendor/utils/VendorGetServerSideProps';
import { configureSSR } from 'src/utils/configureSSR';
import { QueryKey } from 'src/models/query';
import {
  fetchAboutUs,
  useAboutUsQuery,
} from 'src/modules/about-us/hooks/useAboutUsQuery';
import { AboutUsBanner } from 'src/modules/about-us/components/AboutUsBanner';
import { AboutUsNeedleHeading } from 'src/modules/about-us/components/AboutUsNeedleHeading';
import { AboutUsBannerVideo } from 'src/modules/about-us/components/AboutUsBannerVideo';
import { AboutUsNeauviachannel } from 'src/modules/about-us/components/AboutUsNeauviachannel';
import { AboutUsMap } from 'src/modules/about-us/components/AboutUsMap';
import { AboutUsFacilities } from 'src/modules/about-us/components/AboutUsFacilities';
import { AboutUsHolisticVision } from 'src/modules/about-us/components/AboutUsHolisticVision';
import { AboutUsHeroVideo } from 'src/modules/about-us/components/AboutUsHeroVideo';
import { useTranslate } from 'react-t7e';
import { MetaTitle } from 'src/components/seo/MetaTitle';
import { MetaDescription } from 'src/components/seo/MetaDescription';
import { ProductsLegalMentions } from 'src/modules/products/components/ProductsLegalMentions';

const AboutUsPage = () => {
  const { data } = useAboutUsQuery();
  const { _ } = useTranslate();

  return (
    <>
      <MetaTitle>{_('Company Information, Neauvia in the World')}</MetaTitle>
      <MetaDescription>
        {_(
          'NEAUVIA’s mission is to empower people to proactively, holistically & effectively take control of their ageing process from the inside-out',
        )}
      </MetaDescription>
      <AboutUsBanner titleMsgId="Neauvia provides a disruptive approach and products to the aesthetic market" />
      <AboutUsBannerVideo video={data?.bannerVideo[0]} />
      <AboutUsNeauviachannel videos={data?.aboutUs?.aboutVideos} />
      <AboutUsMap />
      <AboutUsFacilities />
      <AboutUsHeroVideo heroVideo={data?.aboutUs?.heroVideo} />
      <AboutUsNeedleHeading msgId="THE FIRST 24/7 AESTHETIC MEDICINE CHANNEL DEDICATED TO DOCTORS" />
      <AboutUsHolisticVision />
      <ProductsLegalMentions />
    </>
  );
};

export const getServerSideProps = VendorGetServerSideProps((ctx) =>
  configureSSR(ctx, {
    layout: {
      variant: 'default',
      tvbar: true,
    },
    cacheControl: {
      maxAge: 900,
      sMaxAge: 3600,
    },
    actions: {
      common: () => [
        ctx.queryClient.prefetchQuery(QueryKey.AboutUs, () =>
          fetchAboutUs(ctx.apis),
        ),
      ],
    },
  }),
);

export default AboutUsPage;
